// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2LYpe","footer":"ModalError_footer__28aef"};